import React from "react"
import { useFormikContext } from "formik"
import { MenuItem, Select, FormControl } from "@mui/material"
import { STATUSES, RESERVATION_COLORS, ReservationStatus } from "@/constants/reservations"
import i18n from "@/i18n"

const StatusSelector = () => {
  const { values, handleChange } = useFormikContext<{ status: ReservationStatus }>()
  const currentStatus = values.status
  const bgColor = RESERVATION_COLORS[currentStatus]?.main ?? "#6b7280"

  return (
    <FormControl fullWidth data-testid="panel-reservations-status-selector">
      <Select
        name="status"
        value={values.status}
        onChange={handleChange}
        data-testid="panel-reservations-status-selector-select"
        sx={{
          backgroundColor: bgColor,
          borderRadius: "6px",
          "& .MuiSelect-select": {
            color: "white",
            padding: "8px 12px",
            textAlign: "center",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "& .MuiSelect-icon": {
            color: "white",
          },
        }}
      >
        {STATUSES.map((status) => (
          <MenuItem key={status} value={status} data-testid={`panel-reservations-status-selector-option-${status}`}>
            {i18n.t(`app.reservation.status.${status}`)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default StatusSelector
